import { AxiosResponse } from "axios";
import AxiosService from "./Axios";

const WAVEFRORM_FILE_URL_PREFIX = "/waveform-file";

class WaveformFileApi {

    public async getDeviceWaveformFileViews(deviceId: string):  Promise<AxiosResponse<any>> {
        return AxiosService.get(`${WAVEFRORM_FILE_URL_PREFIX}/views/device?deviceId=${deviceId}`);
    }

    public async queryDeviceWaveformFileViews(request: QueryWaveformFileViewRequest):  Promise<AxiosResponse<any>> {
        return AxiosService.post(`${WAVEFRORM_FILE_URL_PREFIX}/view/query`, request);
    }

    public async exportToExcel(id: string):  Promise<AxiosResponse<any>> {
        return AxiosService.post(`${WAVEFRORM_FILE_URL_PREFIX}/export-excel?id=${id}`, '', {
            responseType: "blob"
        });
    }
}

interface QueryWaveformFileViewRequest {
    deviceId: string,
    type: string,
    startTime?: number,
    endTime?: number,
}


export default WaveformFileApi;
